export default "__VITE_ASSET__C$9_r9jf__"